import React from "react";

import PropTypes from "prop-types";

export default function CategoryBadge({ children }) {
  return (
    <div className={"bg-tertiary px-2 w-fit rounded text-sm"}>{children}</div>
  );
}

CategoryBadge.propTypes = {
  children: PropTypes.node,
};
